module.exports = __webpack_public_path__ + "ed87e857df9a3a6ef8419ce12a8a5359.png";